import { formatNumberFractionDigits } from "@/shared/utils/formatNumber.js";
import ComplexTable from "@/shared/components/ComplexTable";
import { fieldTypeMap } from "@/shared/components/SchemaForm";
import PageTitle from "@/shared/components/PageTitle";

const HistoricalProfitPc = {
  data() {
    return {
      total: 0,
      listTotalProfit: 0,
      listTotalVolume: 0,
      totalVolume: 0,
      totalProfit: 0,
    };
  },
  methods: {
    getSearchFormDataSource() {
      return [
        // 开始时间
        {
          name: "settleBeginTime",
          label: this.$t("Common_TableTitle_BeginTime"),
          fieldType: fieldTypeMap.datePicker,
        },
        // 结算时间
        {
          name: "settleEndTime",
          label: this.$t("Common_TableTitle_EndTime"),
          fieldType: fieldTypeMap.datePicker,
        },
        // 信号源名称
        {
          name: "portfolioName",
          label: this.$t("Common_TableTitle_SignalSource"),
          fieldType: fieldTypeMap.textInput,
        },
        // 客户MT4账号
        {
          name: "followAccount",
          label: this.$t("Common_TableTitle_Mt4Account"),
          fieldType: fieldTypeMap.textInput,
        },
        // 客户账号
        {
          name: "loginId",
          label: this.$t("Common_TableTitle_CustomerEmail"),
          fieldType: fieldTypeMap.textInput,
        },
      ];
    },
    getTableData(params) {
      const {
        settleBeginTime,
        settleEndTime,
        portfolioName,
        followAccount,
        loginId,
        pageIndex,
        pageSize,
      } = params;
      const resultParams = {
        type: 1,
        portfolioId: 0,
        settleBeginTime: settleBeginTime,
        settleEndTime: settleEndTime,
        portfolioName: portfolioName ? portfolioName.trim() : undefined,
        followAccount: followAccount ? followAccount.trim() : undefined,
        loginId: loginId ? loginId.trim() : undefined,
        pageIndex: pageIndex,
        pageSize: pageSize,
      };
      return this.$axios
        .post("/api/ShareProfit/GetSignalShareProfitPage", resultParams)
        .then((res) => {
          this.total = res.data.result.total;
          this.listTotalProfit = res.data.result.listTotalProfit;
          this.listTotalVolume = res.data.result.listTotalVolume;
          this.totalProfit = res.data.result.totalProfit;
          this.totalVolume = res.data.result.totalVolume;
          return Promise.resolve(res);
        });
    },
    // 列表总计行
    getHistoricalProfitSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t("Common_Total");
          return;
        }
        if (column.property === "profit") {
          sums[index] = formatNumberFractionDigits(this.listTotalProfit);
          return;
        }
        if (column.property === "currentPeriodVolumes") {
          sums[index] = `${formatNumberFractionDigits(
            this.listTotalVolume
          )} lots`;
          return;
        } else {
          sums[index] = "";
        }
      });

      console.log("sums", sums);

      return sums;
    },
  },

  render() {
    const searchFormDataSource = this.getSearchFormDataSource();

    const columns = [
      // 序号
      {
        prop: "sortNum",
        label: this.$t("Common_TableTitle_Number"),
        width: 80,
      },
      // 开始时间
      {
        prop: "settlementBeginTime",
        label: this.$t("Common_TableTitle_BeginTime"),
        width: 150,
      },
      // 结算时间
      {
        prop: "settlementEndTime",
        label: this.$t("Common_TableTitle_EndTime"),
        width: 150,
      },
      // 获得分润
      {
        prop: "profit",
        label: this.$t("Common_TableTitle_ReceiveProfit"),
        scopedSlots: {
          default: ({ row }) => {
            return formatNumberFractionDigits(row.profit);
          },
        },
      },
      // 分润订单号
      {
        prop: "tmdFinanceFlowId",
        label: this.$t("Common_TableTitle_SettlementProfitOrderNo"),
        scopedSlots: {
          default: ({ row }) => {
            return row.tmdFinanceFlowId || "-";
          },
        },
      },
      // 信号源
      {
        prop: "signalName",
        label: this.$t("Common_TableTitle_SignalSource"),
      },
      // 信号账户
      {
        prop: "signalAccount",
        label: this.$t("Common_TableTitle_SignalAccount"),
      },
      // 分润比例
      {
        prop: "shareProfitPercent",
        label: this.$t("Common_TableTitle_SignalPLSharingRatio"),
        scopedSlots: {
          default: ({ row }) => {
            return `${row.shareProfitPercent} %`;
          },
        },
      },
      // 结算周期
      {
        prop: "durationConfigName",
        label: this.$t("Common_TableTitle_SignalSettlementCycle"),
      },
      // 客户账号
      {
        prop: "followLoginId",
        label: this.$t("Common_TableTitle_CustomerEmail"),
      },
      // 客户MT4账号
      {
        prop: "followAccount",
        label: this.$t("Common_TableTitle_Mt4Account"),
      },
      // 期初净值
      {
        prop: "beginPeriodEquity",
        label: this.$t("Common_TableTitle_InitialEquity"),
        scopedSlots: {
          default: ({ row }) => {
            return formatNumberFractionDigits(row.beginPeriodEquity);
          },
        },
      },
      // 本期入金
      {
        prop: "currentPeriodDeposit",
        label: this.$t("Common_TableTitle_CurrentPeriodDeposit"),
        scopedSlots: {
          default: ({ row }) => {
            return formatNumberFractionDigits(row.currentPeriodDeposit);
          },
        },
      },
      // 结算净值
      {
        prop: "settlementPeriodEquity",
        label: this.$t("Common_TableTitle_SettlementEquity"),
        scopedSlots: {
          default: ({ row }) => {
            return formatNumberFractionDigits(row.settlementPeriodEquity);
          },
        },
      },
      // 本期交易量
      {
        prop: "currentPeriodVolumes",
        label: this.$t("Common_TableTitle_CurrentPeriodVolumes"),
        scopedSlots: {
          default: ({ row }) => {
            return `${formatNumberFractionDigits(
              row.currentPeriodVolumes
            )} lots`;
          },
        },
      },
    ];

    const footerNode = (
      <div class="tableTotalNum">
        {`${this.$t("Total_Accumulated_Profit")}: ${this.totalProfit}`}
        &nbsp;&nbsp;&nbsp;&nbsp;
        {`${this.$t("Common_TableTotalvolumns")}: ${this.totalVolume}`}
      </div>
    );

    return (
      <div class="PageCommon">
        <PageTitle value={this.$t("Menu_Signal_HistoricalProfit")} />
        <ComplexTable
          schemaFormProps={{
            initialValues: {
              settleBeginTime: undefined,
              settleEndTime: undefined,
              portfolioName: "",
              followAccount: "",
              loginId: "",
            },
            dataSource: searchFormDataSource,
          }}
          columns={columns}
          requestApi={this.getTableData}
          showSummary
          summaryMethod={this.getHistoricalProfitSummaries}
          footer={footerNode}
        />
      </div>
    );
  },
};

export default HistoricalProfitPc;
